import { render, staticRenderFns } from "./ActivityFeedComponent.vue?vue&type=template&id=328df28f&scoped=true&"
import script from "./ActivityFeedComponent.vue?vue&type=script&lang=ts&"
export * from "./ActivityFeedComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityFeedComponent.vue?vue&type=style&index=0&id=328df28f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328df28f",
  null
  
)

export default component.exports